import type { ComponentType } from '@grafikr/components';
import type { Cart } from '@grafikr/shopify-typescript/type/json/Cart';

const Component: ComponentType = (node, { emitter }) => {
  const cartTitle = node.querySelector<HTMLSpanElement>('[data-cart-title]');
  const cartEmpty = node.querySelector<HTMLSpanElement>('[data-cart-empty]');
  const count = node.querySelector<HTMLSpanElement>('[data-count]');

  emitter.on('cart:updated', (cart: Cart) => {
    if (count) {
      count.hidden = cart.item_count === 0;
    } else {
      node.hidden = cart.item_count === 0;
    }

    if (cartTitle) {
      cartTitle.hidden = cart.item_count === 0;
    }
    if (cartEmpty) {
      cartEmpty.hidden = cart.item_count > 0;
    }

    if (count) {
      count.textContent = `(${cart.item_count})`;
    } else {
      node.textContent = cart.item_count.toString();
    }
  });
  emitter.on('cart:updated:no-drawer', (cart: Cart) => {
    if (count) {
      count.hidden = cart.item_count === 0;
    } else {
      node.hidden = cart.item_count === 0;
    }

    if (count) {
      count.textContent = `(${cart.item_count})`;
    } else {
      node.textContent = cart.item_count.toString();
    }
  });
};

export default Component;
